(function () {
  try {
    var path = location.pathname || "";
    if (!/^\/collections\//.test(path)) return;
    var u = new URL(location.href);
    var sort = u.searchParams.get("sort_by");
    if (!sort || sort === "most-relevant" || sort === "best-selling") {
      u.searchParams.set("sort_by", "manual");
      location.replace(u.toString());
    }
  } catch (e) {}
})();
